import "sweetalert";
import "../../shared/components/wizard_modal.js";
import "./help_modal/help_toc_manager.js";

jQuery(function () {
  var helpModal = new WizardModal({ class: "admin-large-modal", id: "help-modal", clickOut: true });
  var helpPage = helpModal.addPage({});
  var helpContainer = jQuery('<div class="help-container"></div>');
  var helpContent = jQuery('<div class="help-content"></div>');
  var tocContainer = jQuery('<div class="help-toc-container"></div>');
  var tocManager = new HelpTOCManager(tocContainer);

  // BEHAVIOUR

  onElementWithHelpInserted(decorateWithHelpLink);

  helpModal.container.on("click", "[data-help-link]", function () {
    setHelpPage(jQuery(this).data("help-link"), jQuery(this).data("help-type"));
  });

  jQuery(document).on("click", ".help-link, .help-modal-title", handleHelpLinkClicked);
  jQuery(document).on("click", ".help-table-hide-toc", handleHideTableClicked);

  function openHelpModal(key, type) {
    tocManager.getHelpContents().then(() => showHelpModal(key, type));
  }

  window.openHelpModal = openHelpModal;

  // EVENT HANDLERS

  function handleHelpLinkClicked(event) {
    var helpLink = jQuery(this);
    openHelpModal(helpLink.data("key"), helpLink.data("type"));
    event.preventDefault();
  }

  function handleHideTableClicked() {
    helpContainer.toggleClass("help-hide-toc");
  }

  // HELPER FUNCTIONS

  function showHelpModal(key, typeOfKey) {
    initializeModalContent();
    setHelpPage(key, typeOfKey);
    helpPage.setHeader(
      '<div class="help-modal-title"><div class="help-modal-title-icon"></div><h2 class="help-modal-title-header">Sparkle Help</h2></div>',
    );
    helpModal.show();
    jQuery(helpModal.container).find(".modal-footer").empty();
  }

  // Look for help data attributes and place links
  function onElementWithHelpInserted(handler) {
    MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function (mutations, observer) {
      // fired when a mutation occurs
      handler();
    });

    var target = document.querySelector("#content");
    if (!target) {
      return;
    }
    observer.observe(target, {
      subtree: true,
      attributes: true,
    });

    // Run handler once to check the current dom
    handler();
  }

  function decorateWithHelpLink() {
    jQuery("[data-help]").each(function () {
      insertHelpLink(this);
    });
  }

  function insertHelpLink(element) {
    var $element = jQuery(element);
    var key = $element.data("help");
    $element.removeAttr("data-help");
    $element.removeData("help");
    var $link = jQuery("<a>");
    $link.attr("data-key", key);
    $link.text("?");
    $link.addClass("help-link");
    $link.addClass("help-icon");
    $element.append($link);
    tocManager.addHelpLink(key);
  }

  // Modal methods
  // -------------------
  function initializeModalContent() {
    helpContent.empty();
    helpContainer.append(helpContent, tocContainer);
    helpPage.setBody(helpContainer);
  }

  function render() {
    helpContainer.remove(".help-content");
    helpContainer.append(helpContent);
  }

  function getHelpURL(key, typeOfKey) {
    if (key && !typeOfKey) {
      return "/admin/help_entries/" + key;
    } else if (key && typeOfKey == "tag") {
      return "/admin/help_entries/search?tag=" + key;
    } else if (key && typeOfKey == "type") {
      return "/admin/help_entries/dashboard?type=" + key;
    } else {
      return "/admin/help_entries/dashboard";
    }
  }

  function setHelpPage(key, typeOfKey) {
    tocManager.activateContentTitle(key);
    var url = getHelpURL(key, typeOfKey);

    jQuery.get(url, function (data) {
      var container = jQuery(data).css("display", "block");
      helpContent.empty();
      helpContent.append(container);
      render();
    });
  }
});
